var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.sourceId === null
      ? _c(
          "svg",
          {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Источник: Внешняя ссылка",
                  placement: "top",
                },
                expression:
                  "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: 'Источник: Внешняя ссылка',\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            attrs: {
              width: "18",
              height: "10",
              viewBox: "0 0 18 10",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M7 9H4.75C4.25754 9 3.76991 8.89654 3.31494 8.69552C2.85997 8.4945 2.44657 8.19986 2.09835 7.82843C1.39509 7.07828 1 6.06087 1 5C1 3.93913 1.39509 2.92172 2.09835 2.17157C2.80161 1.42143 3.75544 1 4.75 1H7M11 9H13.25C13.7425 9 14.2301 8.89654 14.6851 8.69552C15.14 8.4945 15.5534 8.19986 15.9017 7.82843C16.6049 7.07828 17 6.06087 17 5C17 3.93913 16.6049 2.92172 15.9017 2.17157C15.1984 1.42143 14.2446 1 13.25 1H11M6 5H12",
                stroke: "#8E9CBB",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            }),
          ]
        )
      : _vm._e(),
    _vm.sourceId === 2
      ? _c(
          "svg",
          {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Источник: Добавлена с hh.ru",
                  placement: "top",
                },
                expression:
                  "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: 'Источник: Добавлена с hh.ru',\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            attrs: {
              width: "20",
              height: "20",
              viewBox: "0 0 20 20",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M9 13V11C9 10.5 8.5 10 8 10H6M6 13V10M6 10V7M15 13V11C15 10.5 14.5 10 14 10H12M12 13V10M12 10V7M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z",
                stroke: "#8E9CBB",
                "stroke-width": "2",
                "stroke-linecap": "round",
              },
            }),
          ]
        )
      : _vm._e(),
    _vm.sourceId === 5
      ? _c(
          "svg",
          {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Источник: Ссылка от сотрудника",
                  placement: "top",
                },
                expression:
                  "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: 'Источник: Ссылка от сотрудника',\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            attrs: {
              width: "16",
              height: "18",
              viewBox: "0 0 16 18",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M13.9902 16.0625C13.9902 16.6148 14.4379 17.0625 14.9902 17.0625C15.5425 17.0625 15.9902 16.6148 15.9902 16.0625H13.9902ZM11.2513 10.9863V9.98628V10.9863ZM4.73896 10.9863V9.98628V10.9863ZM1 14.9745H0H1ZM0 16.0625C0 16.6148 0.447715 17.0625 1 17.0625C1.55228 17.0625 2 16.6148 2 16.0625H0ZM15.9902 16.0625V14.9745H13.9902V16.0625H15.9902ZM15.9902 14.9745C15.9902 13.6716 15.5056 12.4102 14.6246 11.4705L13.1656 12.8383C13.687 13.3945 13.9902 14.1619 13.9902 14.9745H15.9902ZM14.6246 11.4705C13.7416 10.5286 12.5297 9.98628 11.2513 9.98628V11.9863C11.9561 11.9863 12.6462 12.2843 13.1656 12.8383L14.6246 11.4705ZM11.2513 9.98628H4.73896V11.9863H11.2513V9.98628ZM4.73896 9.98628C3.46052 9.98628 2.24859 10.5286 1.36558 11.4705L2.82465 12.8383C3.34403 12.2843 4.03413 11.9863 4.73896 11.9863V9.98628ZM1.36558 11.4705C0.484619 12.4102 0 13.6716 0 14.9745H2C2 14.1619 2.30323 13.3945 2.82465 12.8383L1.36558 11.4705ZM0 14.9745V16.0625H2V14.9745H0ZM9.95503 3.99117C9.95503 5.09086 9.06355 5.98234 7.96386 5.98234V7.98234C10.1681 7.98234 11.955 6.19543 11.955 3.99117H9.95503ZM7.96386 5.98234C6.86417 5.98234 5.97269 5.09086 5.97269 3.99117H3.97269C3.97269 6.19543 5.7596 7.98234 7.96386 7.98234V5.98234ZM5.97269 3.99117C5.97269 2.89148 6.86417 2 7.96386 2V0C5.7596 0 3.97269 1.78691 3.97269 3.99117H5.97269ZM7.96386 2C9.06355 2 9.95503 2.89148 9.95503 3.99117H11.955C11.955 1.78691 10.1681 0 7.96386 0V2Z",
                fill: "#8E9CBB",
              },
            }),
          ]
        )
      : _vm._e(),
    _vm.sourceId === 4
      ? _c(
          "svg",
          {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Источник: Заполнена на сайте",
                  placement: "top",
                },
                expression:
                  "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: 'Источник: Заполнена на сайте',\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            attrs: {
              width: "18",
              height: "16",
              viewBox: "0 0 18 16",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M6 15H12M9 15V11M3 1H15C16.1046 1 17 1.89543 17 3V9C17 10.1046 16.1046 11 15 11H3C1.89543 11 1 10.1046 1 9V3C1 1.89543 1.89543 1 3 1Z",
                stroke: "#8E9CBB",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
              },
            }),
          ]
        )
      : _vm._e(),
    _vm.sourceId === 3
      ? _c(
          "svg",
          {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Источник: Заполнена вручную",
                  placement: "top",
                },
                expression:
                  "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: 'Источник: Заполнена вручную',\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            attrs: {
              width: "18",
              height: "17",
              viewBox: "0 0 18 17",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M11.4674 1.63741L12.1745 2.34453L12.1745 2.34452L11.4674 1.63741ZM12.163 1.17258L12.5457 2.09646L12.163 1.17258ZM13.8042 1.17258L13.4215 2.09646L13.8042 1.17258ZM14.4999 1.63741L15.207 0.930304V0.930304L14.4999 1.63741ZM14.4999 4.66992L15.207 5.37704L15.207 5.37703L14.4999 4.66992ZM5.16971 13.9999L5.43283 14.9646C5.60073 14.9188 5.75376 14.83 5.87682 14.707L5.16971 13.9999ZM1 15.137L0.0352364 14.8739C-0.0591854 15.2201 0.0391427 15.5904 0.292893 15.8442C0.546643 16.0979 0.916904 16.1962 1.26312 16.1018L1 15.137ZM2.13719 10.9673L1.4301 10.2602C1.30704 10.3833 1.21822 10.5363 1.17243 10.7042L2.13719 10.9673ZM14.8328 4.27052C14.3334 4.0346 13.7374 4.24815 13.5015 4.74751C13.2655 5.24687 13.4791 5.84293 13.9784 6.07885L14.8328 4.27052ZM17 7.13584H18C18 6.86079 17.8867 6.5979 17.6868 6.40899L17 7.13584ZM17 12.3959L17.7322 13.0769C17.9043 12.8919 18 12.6485 18 12.3959H17ZM7.5 13L7.49998 12H7.49998L7.5 13ZM12 11C12.5523 11 13 10.5523 13 10C13 9.44771 12.5523 9 12 9V11ZM5.58489 3.21352L4.90132 2.48363L5.58489 3.21352ZM2.47172 6.35833L3.1585 7.0852C3.24814 7.0005 3.32134 6.89995 3.37441 6.78863L2.47172 6.35833ZM1.78167 9.53355C2.18141 9.91464 2.81439 9.89953 3.19548 9.4998C3.57658 9.10007 3.56147 8.46708 3.16173 8.08599L1.78167 9.53355ZM10.1429 3.71499C10.6814 3.83757 11.2173 3.50039 11.3399 2.96188C11.4624 2.42337 11.1253 1.88745 10.5868 1.76487L10.1429 3.71499ZM7.03702 13.5468C7.42755 13.1562 7.42755 12.5231 7.03702 12.1325C6.6465 11.742 6.01333 11.742 5.62281 12.1325L7.03702 13.5468ZM12.1745 2.34452C12.2807 2.23826 12.4069 2.15397 12.5457 2.09646L11.7803 0.248702C11.3989 0.406718 11.0522 0.638326 10.7603 0.930304L12.1745 2.34452ZM12.5457 2.09646C12.6845 2.03895 12.8333 2.00936 12.9836 2.00936V0.0093565C12.5707 0.0093565 12.1618 0.0906863 11.7803 0.248702L12.5457 2.09646ZM12.9836 2.00936C13.1339 2.00936 13.2827 2.03895 13.4215 2.09646L14.1869 0.248702C13.8054 0.0906863 13.3965 0.0093565 12.9836 0.0093565V2.00936ZM13.4215 2.09646C13.5604 2.15397 13.6865 2.23826 13.7928 2.34452L15.207 0.930304C14.915 0.638327 14.5684 0.406719 14.1869 0.248702L13.4215 2.09646ZM13.7928 2.34452C13.899 2.45078 13.9833 2.57693 14.0408 2.71576L15.8886 1.95039C15.7306 1.5689 15.499 1.22228 15.207 0.930304L13.7928 2.34452ZM14.0408 2.71576C14.0983 2.85459 14.1279 3.00339 14.1279 3.15367H16.1279C16.1279 2.74075 16.0466 2.33188 15.8886 1.95039L14.0408 2.71576ZM14.1279 3.15367C14.1279 3.30394 14.0983 3.45274 14.0408 3.59157L15.8886 4.35695C16.0466 3.97546 16.1279 3.56658 16.1279 3.15367H14.1279ZM14.0408 3.59157C13.9833 3.73041 13.899 3.85656 13.7928 3.96282L15.207 5.37703C15.499 5.08506 15.7306 4.73843 15.8886 4.35695L14.0408 3.59157ZM4.9066 13.0351L0.736883 14.1723L1.26312 16.1018L5.43283 14.9646L4.9066 13.0351ZM1.96476 15.4002L3.10196 11.2305L1.17243 10.7042L0.0352364 14.8739L1.96476 15.4002ZM2.84429 11.6745L12.1745 2.34453L10.7603 0.930295L1.4301 10.2602L2.84429 11.6745ZM13.7928 3.96281L8.46271 9.29272L9.8769 10.707L15.207 5.37704L13.7928 3.96281ZM13.9784 6.07885C14.3731 6.26532 14.9374 6.68205 15.4547 7.10981C15.7012 7.3136 15.9177 7.50353 16.0725 7.64251C16.1497 7.71182 16.2111 7.768 16.2526 7.80635C16.2734 7.82551 16.2891 7.84018 16.2994 7.84978C16.3045 7.85457 16.3083 7.85809 16.3106 7.86027C16.3118 7.86136 16.3125 7.86211 16.313 7.86251C16.3132 7.86272 16.3133 7.86283 16.3133 7.86286C16.3134 7.86287 16.3134 7.86286 16.3133 7.86283C16.3133 7.86282 16.3133 7.86278 16.3133 7.86277C16.3132 7.86273 16.3132 7.86268 17 7.13584C17.6868 6.40899 17.6867 6.40893 17.6866 6.40887C17.6866 6.40884 17.6865 6.40876 17.6865 6.4087C17.6863 6.40858 17.6862 6.40844 17.686 6.40828C17.6857 6.40795 17.6852 6.40753 17.6847 6.40702C17.6836 6.40601 17.6821 6.40464 17.6803 6.40293C17.6767 6.39951 17.6716 6.39472 17.6651 6.38862C17.652 6.37643 17.6333 6.35902 17.6095 6.33701C17.5618 6.293 17.4935 6.23044 17.4085 6.1542C17.2391 6.00207 17.0015 5.79364 16.7291 5.56843C16.2088 5.13819 15.4759 4.57435 14.8328 4.27052L13.9784 6.07885ZM16 7.13584V12.3959H18V7.13584H16ZM17 12.3959C16.2677 11.7148 16.268 11.7145 16.2682 11.7142C16.2683 11.7142 16.2686 11.7139 16.2688 11.7137C16.2691 11.7133 16.2694 11.713 16.2697 11.7127C16.2703 11.7121 16.2708 11.7116 16.2712 11.7111C16.272 11.7103 16.2724 11.7098 16.2726 11.7096C16.2728 11.7094 16.2717 11.7105 16.2693 11.713C16.2644 11.718 16.2542 11.7282 16.2387 11.7431C16.2078 11.7728 16.1562 11.8204 16.0849 11.8801C15.9418 12.0001 15.7227 12.1661 15.4349 12.3335C14.8593 12.6685 14.0263 12.9999 12.9787 12.9999V14.9999C14.4606 14.9999 15.6383 14.5292 16.4408 14.0622C16.8422 13.8286 17.1541 13.5936 17.3698 13.4128C17.4779 13.3222 17.5626 13.2445 17.6231 13.1865C17.6534 13.1575 17.6777 13.1333 17.6959 13.1147C17.705 13.1055 17.7126 13.0976 17.7186 13.0913C17.7217 13.0881 17.7243 13.0853 17.7266 13.0829C17.7277 13.0817 17.7287 13.0806 17.7297 13.0796C17.7302 13.0791 17.7306 13.0786 17.731 13.0782C17.7312 13.0779 17.7315 13.0776 17.7316 13.0775C17.7319 13.0772 17.7322 13.0769 17 12.3959ZM12.9787 12.9999C12.2981 12.9999 11.8606 12.9422 11.5434 12.8691C11.2262 12.7961 10.9973 12.7015 10.6891 12.5749C9.98595 12.2861 9.2244 12 7.49998 12L7.50002 14C8.91289 14 9.41517 14.2138 9.92928 14.4249C10.2297 14.5483 10.5979 14.7037 11.0943 14.8181C11.5909 14.9325 12.1838 14.9999 12.9787 14.9999V12.9999ZM7.49998 12C7.28016 12 7.16678 11.9341 7.11729 11.8877C7.07846 11.8514 7 11.7558 7 11.5H5C5 12.2248 5.24996 12.8792 5.75034 13.3477C6.24006 13.8062 6.87668 14 7.50002 14L7.49998 12ZM7 11.5C7 11.2442 7.07845 11.1486 7.11729 11.1123C7.16678 11.0659 7.28016 11 7.5 11V9C6.87668 9 6.24006 9.19379 5.75034 9.65231C5.24997 10.1208 5 10.7752 5 11.5H7ZM7.5 11H12V9H7.5V11ZM4.90132 2.48363C3.43583 3.85612 2.63885 4.65998 2.20269 5.12886C1.98474 5.36317 1.849 5.52223 1.76198 5.63292C1.71817 5.68864 1.68273 5.73714 1.65358 5.78091C1.63881 5.80309 1.62447 5.82582 1.61083 5.84923C1.60394 5.86103 1.597 5.8734 1.59009 5.88635C1.58663 5.89284 1.58313 5.89955 1.57963 5.90647C1.57788 5.90993 1.57612 5.91346 1.57435 5.91705C1.57347 5.91885 1.57259 5.92066 1.5717 5.92249C1.57126 5.92341 1.57059 5.92479 1.57037 5.92525C1.5697 5.92664 1.56904 5.92803 2.47172 6.35833C3.37441 6.78863 3.37375 6.79002 3.37308 6.79141C3.37286 6.79186 3.3722 6.79323 3.37176 6.79414C3.37089 6.79594 3.37002 6.79772 3.36917 6.79946C3.36745 6.80295 3.36577 6.80632 3.36412 6.80957C3.36083 6.81607 3.35767 6.82215 3.35467 6.82777C3.34868 6.83898 3.3432 6.8487 3.33848 6.8568C3.32915 6.87281 3.3219 6.88397 3.31822 6.8895C3.31126 6.89996 3.31401 6.89477 3.33426 6.86902C3.37537 6.81673 3.47122 6.70161 3.66708 6.49106C4.05856 6.07021 4.81816 5.30166 6.26846 3.9434L4.90132 2.48363ZM1.78494 5.63147C1.29472 6.09465 1.04181 6.80009 1.0048 7.44988C0.966452 8.12313 1.1499 8.93124 1.78167 9.53355L3.16173 8.08599C3.06299 7.99185 2.98699 7.81938 3.00156 7.5636C3.00856 7.44076 3.03656 7.32412 3.07524 7.22985C3.0942 7.18363 3.1137 7.14774 3.13048 7.12199C3.13873 7.10933 3.14571 7.10008 3.15086 7.09381C3.15604 7.08751 3.15878 7.08493 3.1585 7.0852L1.78494 5.63147ZM10.5868 1.76487C9.9171 1.61244 8.95342 1.35872 7.98467 1.34819C6.97102 1.33718 5.85959 1.58617 4.90132 2.48363L6.26846 3.9434C6.74952 3.49287 7.30699 3.34095 7.96294 3.34807C8.6638 3.35569 9.37042 3.53917 10.1429 3.71499L10.5868 1.76487ZM5.87682 14.707L7.03702 13.5468L5.62281 12.1325L4.46261 13.2927L5.87682 14.707Z",
                fill: "#8E9CBB",
              },
            }),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }